<template>
  <div class="container-fluid m-3">
    <h2>Tabellen</h2>
    <div class="btn-toolbar" role="toolbar">
      <a href="/trendshop.proxy.web/tables/schema/new"><button class="btn btn-primary">Neu</button></a>
    </div>
    <b-table @row-clicked="openSchema" class="mt-3 table-striped" :items="schemas" :fields="fields"/>
  </div>
</template>

<script>
import router from '@/router'
import tables from '@/modules/tables.js'

export default {
  data() {
    return {
      start: 0,
      count: 25,
      schemas: [],
      fields: [
        {key: 'id', label: 'ID'},
        {key: 'tableId', label: 'Tabelle'},
        {key: 'description',label: 'Beschreibung'},
        {key: 'owner', label: 'Besitzer'}
      ]
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      var self = this;
      tables.listTables(this.start,this.count).then(function(data) {
        console.log(data);
        self.schemas = data;
      })
    },
    openSchema(item) {
      console.log(item);
      router.push({name: 'TableSchemaEditor', params: {id: item.tableId }});
    }
  }
}
</script>
